<ul class="primary-actions">
  <li>
    <button (click)="hangUp()" class="quickActionIcon">
      <span class="quickActionIconBg cng-ico_raccrocher"></span>
      <span aria-hidden="true" class="quickActionLabel">
        {{ 'agent:contact.actions.hang_up_video' | translate }}
      </span>
    </button>
  </li>
</ul>
<div class="secondary-actions">
  <ng-container *ngIf="{ isRecordInProgress: isRecordInProgress$ | async } as data">
    <ul>
      <li [hidden]="data.isRecordInProgress" *cngHasPermission="'CSR_VISIO_OUTGOING::csr_visio_record:start'">
        <button [disabled]="appointmentId === undefined" (click)="startVisioRecord()">
          {{ 'agent:contact.actions.record' | i18next }}
        </button>
      </li>
      <li [hidden]="!data.isRecordInProgress" *cngHasPermission="'CSR_VISIO_OUTGOING::csr_visio_record:stop'">
        <button (click)="stopVisioRecord()">{{ 'agent:contact.actions.stop_record' | i18next }}</button>
      </li>
    </ul>
  </ng-container>
  <ul>
    <li>
      <button type="button" disabled>{{ 'agent:panel.visio.inviteCsr' | translate }}</button>
    </li>
    <li>
      <button type="button" disabled>{{ 'agent:panel.visio.inviteParticipant' | translate }}</button>
    </li>
  </ul>
  <ul>
    <li>
      <button type="button" disabled>{{ 'agent:panel.visio.send' | translate }}</button>
    </li>
    <li>
      <button type="button" disabled>{{ 'agent:panel.visio.scheduleAppointment' | translate }}</button>
    </li>
  </ul>
</div>
